import monthLabels from "./typings";
var buildLineChart = function (data, language) {
    var _a;
    return (_a = data.scores) === null || _a === void 0 ? void 0 : _a.map(function (monthlyScore) {
        var _a, _b, _c;
        // Example date: 2023-08-29
        var month = (_a = monthlyScore.generatedDate) === null || _a === void 0 ? void 0 : _a.split("-")[1];
        var monthLabel = language === "es" ? (_b = monthLabels[month]) === null || _b === void 0 ? void 0 : _b.es : (_c = monthLabels[month]) === null || _c === void 0 ? void 0 : _c.en;
        return {
            month: monthLabel,
            score: monthlyScore.creditScore,
        };
    }).reverse();
};
export default buildLineChart;
